<template>
  <div class="pdf-preview" v-show="visible">
    <div class="pdf-wrapper">
      <Draggable :controlEl="el" :fill="true">
        <div class="head">
          <Icon :src="require('@/assets/images/hl.png')" size="16" style="margin-right: 0.5rem" />
          <span>PDF预览</span>
          <div class="close-btn" @click="handleClose">
            <div class="area-popup_close">
              <Icon :src="require('@/assets/images/close.png')" size="24" />
            </div>
          </div>
        </div>
      </Draggable>
      <div class="pdf-container" v-if="visible">
        <iframe :src="pdfUrl" frameborder="0" width="100%" height="100%"></iframe>
      </div>
      <!-- <div class="download-btn" v-if="canDownload">
        <el-button type="primary" @click="downloadPdf">下载</el-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import Icon from "@/components/UI/Icon";
import Draggable from "@/components/Popup/Draggable.vue";
export default {
  name: 'PdfPreview',
  components: {
    pdf,
    Icon,
    Draggable
  },
  data() {
    return {
      el: null,
      visible: false,
      pdfUrl: ''
    }
  },
  computed: {
    canDownload() {
      return this.$store.state.userRights.get('download_fish_info')
    }
  },
  methods: {
    handleClose() {
      this.visible = false
    }
  },
  mounted() {
    this.el = this.$el
  }
}
</script>

<style lang="scss" scoped>
.pdf-preview {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 90%;
  z-index: 2000;
}

.pdf-wrapper {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);

  .head {
    padding: 12px 16px;
    color: white;
    background-color: rgba(68, 138, 202, 1);
    position: relative;
    text-align: left;
    box-sizing: border-box;
    flex-shrink: 0;

    .area-popup_close {
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
      cursor: pointer;
      transition: all ease-out 0.25s;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }

  .pdf-container {
    flex: 1;
    display: flex;
    background: #525659;
    height: max-content;
    overflow: auto;

    .pdf-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      padding: 20px;
      height: calc(100% - 40px);
      overflow: auto;
    }
  }
  .download-btn {
    text-align: center;
    padding: 10px;
  }
}

</style> 


// WEBPACK FOOTER //
// src/components/PdfPreviewSymbol/PdfPreviewSymbol.vue